<!-- <div class="col-xl-2 col-sm-6 col-12 mb-2 mb-xl-0"> -->
    <div class="media" placement="top" [ngbTooltip]="data?.summary">
        <div class="avatar mr-2" [ngClass]="{'bg-light-danger': data?.sentiment == 'Extreme Fear', 'bg-light-warning': data?.sentiment == 'Fear', 'bg-light-success': data?.sentiment == 'Greed' || data?.sentiment == 'Extreme Greed'}">
            <div class="avatar-content">
                <ng-container *ngTemplateOutlet="icon; context: { sentiment: data?.sentiment}"></ng-container>
            </div>
        </div>
        <div class="media-body my-auto">
            <h4 class="font-weight-bolder mb-0">
                {{data?.indicator}}
            </h4>
            <p class="card-text mb-0">{{data?.sentiment}}</p>
        </div>
    </div>
<!-- </div> -->

<ng-template #icon let-sentiment="sentiment">
    <i *ngIf="sentiment == 'Extreme Fear'" data-feather="alert-triangle" class="avatar-icon"></i>
    <i *ngIf="sentiment == 'Fear'" data-feather="alert-triangle" class="avatar-icon"></i>
    <i *ngIf="sentiment == 'Greed'" data-feather="pocket" class="avatar-icon"></i>
    <i *ngIf="sentiment == 'Extreme Greed'" data-feather="pocket" class="avatar-icon"></i>
  <i *ngIf="sentiment == 'Neutral'" data-feather="minus-square" class="avatar-icon"></i>
</ng-template>
